import type { CsvAnalysis } from 'troppus-common/shared';

export function delimiterLabel(d: CsvAnalysis['detectedDelimiter']): string {
  if (d === '\t') return 'TAB';
  if (d === '|') return '| (パイプ)';
  return ', (カンマ)';
}

export function encodingLabel(e: CsvAnalysis['detectedEncoding']): string {
  return e === 'shift_jis' ? 'Shift_JIS' : 'UTF-8';
}
